import React from "react";
import Link from "next/link";
import styles from "./ActionView.module.css";
import useAction from "../../../hooks/data/useAction";
import Icon from "../../common/Icon/Icon";
import Typography from "../../common/Typography/Typography";
import formatTimestamp from "../../../helpers/formatTimestamp";
import ImageGallery from "../../ImageGallery/ImageGallery";
import { AWS_VISIT_IMAGE_URL_PREFIX } from "../../../config/global.config";
import useActionImages from "../../../hooks/data/useActionImages";
import Card from "../../common/Card/Card";
import Loading from "../../Loading/Loading";
import Spinner from "../../common/Spinner/Spinner";

interface Props {
    actionId: string;
}

export const ActionViewDetails = ({ actionId }: Props) => {
    const { action } = useAction(actionId);
    const { images, isLoading: isImagesLoading } = useActionImages(actionId as string);

    const imageData = images.map((img) => ({
        src: AWS_VISIT_IMAGE_URL_PREFIX + img.AmazonGUID,
        label: img.Note,
        id: img.ID,
    }));

    return (
        <div className={["flex-grow flex flex-col space-y-1.5", styles.padding].join(" ")}>
            <Link href={`/sites/${action?.SiteRef}`} className="flex type-meta justify-between w-full sm:w-1/2">
                <span className="grid grid-cols-1 text-left">
                    {action?.SiteName}
                    <span className="text-pine-600">{action?.FindingArea}</span>
                </span>
                <Icon className="w-fit shrink-0" icon="arrow_right" />
            </Link>
            <Link href={`/sites/${action?.SiteRef}/visits/${action?.VisitID}`} className="flex type-meta justify-between w-full sm:w-1/2">
                <span>Visit #{action?.VisitID}</span>
                <Icon className="w-fit shrink-0" icon="arrow_right" />
            </Link>
            <Typography as="p" variant="meta" color="pine">
                Raised by <span className="text-midnight-500">{action?.ActionByCustomer}</span> on{" "}
                <span className="text-midnight-500">{formatTimestamp(action?.AddedTS as string, "DD/MM/YYYY")}</span>
            </Typography>
            <Loading isLoading={isImagesLoading} loadingFallback={<Spinner />}>
                {imageData.length > 0 ? (
                    <Card padding="none">
                        <ImageGallery images={imageData} imageTile />
                    </Card>
                ) : null}
            </Loading>
            <div className="flex-grow">
                <Typography as="p">{action?.Findings}</Typography>
            </div>
        </div>
    );
};
